"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _default = /*#__PURE__*/(0, _react.createContext)(undefined);

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVDb250ZXh0IiwidW5kZWZpbmVkIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvcHJvdmlkZXJzL1BvbnlmaWxsL3ByaXZhdGUvUG9ueWZpbGxDb250ZXh0LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNyZWF0ZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB0eXBlIHsgR2xvYmFsU2NvcGVQb255ZmlsbCB9IGZyb20gJ2JvdGZyYW1ld29yay13ZWJjaGF0LWNvcmUnO1xuXG50eXBlIFBvbnlmaWxsQ29udGV4dFR5cGUgPSB7XG4gIHBvbnlmaWxsU3RhdGU6IHJlYWRvbmx5IFtHbG9iYWxTY29wZVBvbnlmaWxsXTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNyZWF0ZUNvbnRleHQ8UG9ueWZpbGxDb250ZXh0VHlwZSB8IHVuZGVmaW5lZD4odW5kZWZpbmVkKTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs0QkFRZSxJQUFBQSxvQkFBQSxFQUErQ0MsU0FBL0MsQyJ9